import { authenticatedFetch } from '../shared/authenticatedFetch';

export interface PromptEntry {
  name: string;
  content: string;
}

export async function getPrompts(apiUrl: string): Promise<PromptEntry[]> {
  const response = await authenticatedFetch(`${apiUrl}/prompts`);
  return response.json();
}
